/*
 * $Id:: utils.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { ListItem, Typography, Collapse, List, MenuItem } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useLocation } from 'react-router-dom';

import LaunchIcon from '../../assets/images/launch_24px.svg';
import { t } from '../../providers';

export const viewableItems = ({ items, navigateTo, userType, authorities, rootPath, sidebarType, classes, location, setDialogOpen }) => {
    const findAuthSubmenu = (submenu = []) =>
        submenu.find((sm) => sm.path.startsWith(rootPath) || (sm.includeParam && sm.path === location.pathname));
    const findUnAuthSubmenu = (submenu = []) => submenu.find((sm) => sm.path === rootPath || (sm.includeParam && sm.path === location.pathname));

    const menuAction = (hasSubMenu, e, path, externalPath, id) => {
        const subMenus = document.querySelectorAll('[id^="subMenu_"]');
        const arraySubMenu = Array.prototype.slice.call(subMenus, 0);
        const openedSubMenu = arraySubMenu.filter(function (element) {
            return element.id.indexOf(id) < 0 && window.getComputedStyle(element).display === 'block';
        });
        const parentElement = document.getElementById(`parent_${id}`);

        if (openedSubMenu.length > 0 && openedSubMenu[0].id.replace('subMenu_', '') !== id) {
            openedSubMenu[0].style.display = 'none';
            const openedExpandMoreIcon = document.getElementById(`expandLess${openedSubMenu[0].id.replace('subMenu_', '')}`);
            const openedExpandLessIcon = document.getElementById(`expandMore${openedSubMenu[0].id.replace('subMenu_', '')}`);
            openedExpandMoreIcon.style.display = 'none';
            openedExpandLessIcon.style.display = 'block';
            openedSubMenu[0].previousElementSibling.setAttribute('aria-expanded', false);
        }

        if (hasSubMenu) {
            const el = document.getElementById(`subMenu_${id}`);
            const expandMoreIcon = document.getElementById(`expandLess${id}`);
            const expandLessIcon = document.getElementById(`expandMore${id}`);
            if (el.style.display === 'none') {
                el.style.display = 'block';
                expandMoreIcon.style.display = 'block';
                expandLessIcon.style.display = 'none';
                parentElement.setAttribute('aria-expanded', true);
            } else {
                el.style.display = 'none';
                expandMoreIcon.style.display = 'none';
                expandLessIcon.style.display = 'block';
                parentElement.setAttribute('aria-expanded', false);
            }
        } else {
            if (path === 'logout') {
                setDialogOpen(true);
            } else {
                navigateTo(e, path, externalPath);
            }
        }
    };

    return items
        .filter(({ cannotAccess }) => !cannotAccess || !cannotAccess(userType, authorities))
        .map(({ key, value, id, path, submenu = [], externalPath = false, logout = false, subMenuOpen = false }) => {
            let selectedSubmenu = null;
            let isSelected = !submenu.length && rootPath === path; // unauthorized user OR  authorized user with rootPath: '/'
            if (sidebarType === 'auth' && rootPath !== '/') {
                // authorized user
                isSelected = !submenu.length && path && path.startsWith(rootPath);

                if (!isSelected) {
                    isSelected = !submenu.length && !!findAuthSubmenu(submenu);
                }
            }

            if (!isSelected) {
                selectedSubmenu = !!submenu.length && !!findUnAuthSubmenu(submenu);
            }

            const selectedClass = (isSelected && ` ${classes.selectedOption}`) || '';
            const colorClass = (isSelected && !selectedSubmenu && ` ${classes.selectedColorOption}`) || '';
            const ariaCurrent = (isSelected && !selectedSubmenu && { 'aria-current': 'page' }) || {};
            const optionClass = `${classes.cursorPointer}${selectedClass}`;
            const separator =
                (externalPath || logout) && (value === 'edelivery' || value === 'electronic.communication.management' || value === 'log.out');
            const userlocation = useLocation();

            // submenus construction
            const subMenus = submenu.map((item) => {
                const ariaCurrentForSubMenu = item.path === userlocation.pathname ? { 'aria-current': 'page' } : {};
                return (
                    <Collapse in={subMenuOpen} timeout="auto" unmountOnExit>
                        {authorities.includes('ROLE_' + item.value.toUpperCase()) ? (
                            <List component="div" disablePadding>
                                <ListItem
                                    {...ariaCurrentForSubMenu}
                                    role="link"
                                    button
                                    aria-disabled={undefined}
                                    className={`${classes.menuItm} ${item.path === userlocation.pathname ? classes.selectedColorOption : ''}`}
                                    onClick={(e) => menuAction(false, e, item.path, item.externalPath, '')}>
                                    <Typography
                                        className={`${classes.submenuOption} ${item.path === userlocation.pathname ? classes.selectedColorItem : ''}`}
                                        onClick={(e) => menuAction(false, e, item.path, item.externalPath, '')}>
                                        {t(item.value)}
                                    </Typography>
                                </ListItem>
                            </List>
                        ) : (
                            <div />
                        )}
                    </Collapse>
                );
            });

            const menuBtnAttributes = !!submenu.length ? { 'aria-haspopup': true, 'aria-controls': `subMenu_${id}`, 'aria-expanded': false } : {};

            const handleEscBtn = (event) => {
                if (event.key === 'Escape') {
                    // only if key is pressed on a parent menu option
                    if (!!submenu.length) {
                        const el = document.getElementById(`subMenu_${id}`);
                        // only if submenus are visible
                        if (el.style.display !== 'none') {
                            // hide submenu options
                            menuAction(!!submenu.length, {}, path, externalPath, id);
                        }
                    }
                }
            };

            return (
                <>
                    {separator && <div style={{ height: '25px' }}></div>}
                    <ListItem
                        {...menuBtnAttributes}
                        {...ariaCurrent}
                        id={`parent_${id}`}
                        role={!!submenu.length ? 'button' : 'link'}
                        button
                        key={key}
                        onKeyDown={handleEscBtn}
                        aria-disabled={undefined}
                        onClick={(e) => menuAction(!!submenu.length, e, path, externalPath, id)}
                        className={`${classes.sidebarOption} ${colorClass}`}>
                        <Typography id={id} className={`${optionClass}  ${classes.sidebarOptionTitle}`}>
                            {`${t(value)}`}
                        </Typography>
                        {externalPath && (
                            <img
                                src={LaunchIcon}
                                style={{ verticalAlign: 'middle', position: 'absolute', right: '5px', width: '18px', top: '10px' }}
                                alt={t('open.new.tab')}
                            />
                        )}
                        {!!submenu.length && (
                            <>
                                <ExpandMoreIcon
                                    aria-hidden="true"
                                    focusable="false"
                                    id={`expandMore${id}`}
                                    className={classes.subMenuIcon}
                                    style={{ display: 'block', position: 'absolute', right: '5px' }}
                                />
                                <ExpandLessIcon
                                    aria-hidden="true"
                                    focusable="false"
                                    id={`expandLess${id}`}
                                    className={classes.subMenuIcon}
                                    style={{ position: 'absolute', right: '5px' }}
                                />
                            </>
                        )}
                    </ListItem>
                    {!!submenu.length && (
                        <div id={`subMenu_${id}`} style={{ paddingBottom: '8px', display: 'none' }} aria-labelledby={`parent_${id}`}>
                            {subMenus}
                        </div>
                    )}
                </>
            );
        });
};
